<template>
  <div>
    <div class="fontMono">
      <div>
        <div class="table-container">
          <table class="table is-bordered is-narrow">
            <tr>
              <td colspan="6" style="padding-bottom: 0px; padding-top: 0px">
                <h2 class="title">
                  {{ empresa.nombrec }}
                  <small class="title is-4 has-text-grey"
                    >Nit: {{ empresa.nit | textnumber()
                    }}{{ empresa.nit | dverif() }}</small
                  >
                </h2>
                <h2 class="subtitle is-6">{{ empresa.nombre }}</h2>
              </td>
              <td colspan="5" class="has-text-right">
                <h2 class="title is-3">
                  {{ data.comprobante.prefijo }}
                  {{ registros[0].documento }}
                </h2>
              </td>
            </tr>
            <tr>
              <td colspan="11">
                {{ empresa.ciudad }} {{ empresa.direccion }} Tel:
                {{ empresa.telefono }}
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <h3 class="title is-capitalized">
                  {{
                    data.comprobante.titulo
                      ? data.comprobante.titulo
                      : data.comprobante.nombre
                  }}
                </h3>
              </td>
              <td
                colspan="5"
                style="padding-bottom: 0px; padding-top: 0px"
                class="has-text-right"
              >
                <h3
                  class="title is-4"
                  style="padding-top: 1px; margin-top: 5px"
                >
                  {{ registros[0].fecha | date() }}
                </h3>
              </td>
            </tr>
            <tr class="has-background-light">
              <th>Cuenta</th>
              <th>Nit</th>
              <th>Descripción</th>
              <th>Ref</th>
              <th>CC</th>
              <th>Producto</th>
              <th>Cant</th>
              <th>$</th>
              <th>Bod</th>
              <th>Debito</th>
              <th>Credito</th>
            </tr>
            <tr v-for="(registro, index) in registros1" :key="index">
              <td :class="{ 'has-background-light': registro.esTotal }">
                <small
                  >{{ registro.idcuenta.codigo }}
                  {{ registro.idcuenta.nombre }}</small
                >
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                <small>
                  {{
                    registro.idnit.nombre == "NA" ? "" : registro.idnit.nombre
                  }}
                  {{
                    registro.idnit.nombre == "NA" ? "" : registro.idnit.codigo
                  }}
                </small>
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                <small>{{ registro.descripcion }}</small>
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                {{ registro.docRef }}
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                {{ registro.ccostos }}
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                <small>
                  <strong>{{
                    registro.producto ? registro.producto.codigo : ""
                  }}</strong>
                  {{ registro.producto ? registro.producto.descripcion : "" }}
                  {{ registro.producto ? registro.producto.marca : "" }}
                </small>
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                {{ registro.cantidad }}
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                {{ registro.vlrUnitario }}
              </td>
              <td :class="{ 'has-background-light': registro.esTotal }">
                <small
                  >{{ registro.bodega ? registro.bodega.codigo : "" }}
                  {{
                    registro.bodega ? registro.bodega.descripcion : ""
                  }}</small
                >
              </td>
              <td class="has-text-right">
                <span v-show="registro.tipo === 1">{{
                  registro.valor | number(2)
                }}</span>
              </td>
              <td class="has-text-right">
                <span v-show="registro.tipo === 2">{{
                  registro.valor | number(2)
                }}</span>
              </td>
            </tr>
            <tr class="has-background-light">
              <td colspan="9"><strong>Total</strong></td>
              <td class="has-text-right">
                <strong>
                  {{ total.debito | number(2) }}
                </strong>
              </td>
              <td class="has-text-right">
                <strong>
                  {{ total.credito | number(2) }}
                </strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      total: {
        debito: 0,
        credito: 0,
      },
    };
  },
  props: {
    data: Object,
    registros: Array,
  },
  computed: {
    ...mapState(["empresa"]),
    registros1() {
      const _this = this;
      let returned = [];
      for (let index in this.registros) {
        const reg = _this.registros[index];
        if (!reg.orden) {
          reg.orden = index;
        }
        reg.tipo = parseInt(reg.tipo);
        if (reg.tipo === 1) {
          _this.total.debito += reg.valor;
        } else {
          _this.total.credito += reg.valor;
        }
        returned.push(reg);
      }
      returned = functions.order(returned, "orden");
      return returned;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/prints/Printcontable.vue